import { registerPlugin } from "@capacitor/core";
export const CapacitorNativeGoogleAuth = registerPlugin("CapacitorNativeGoogleAuth", {
    web: () => import("./web").then(m => new m.CapacitorNativeGoogleAuthWeb())
});
export * from "./definitions";
//# sourceMappingURL=index.js.map